const envSettings = window as any;
export class Config {
  static api_url = envSettings.API_URL;
  static eu_url = envSettings.EU_PORTAL_API;
  static us_url = envSettings.US_PORTAL_API;
}
